/**
 * Lưu một `Blob` xuống máy người dùng bằng liên kết tải tạm — cho tệp phải tải
 * qua `fetch` kèm token (thẻ `<a href>` không gắn được `Authorization`).
 */
export function luuTep(tep: Blob, tenTep: string): void {
  const url = URL.createObjectURL(tep);
  const a = document.createElement('a');
  a.href = url;
  a.download = tenTep;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Thu hồi ngay có trình duyệt huỷ luôn lượt tải vừa bắt đầu.
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
